import React from "react";
import { Link } from "react-router-dom";
import { useContact } from "../../context/ContactContext";

/**
 * Reusable "global-cta" band used at the bottom of nearly every page.
 * All props are optional — defaults match the copy used site-wide.
 */
export default function GlobalCta({
    heading = <>We are <span className="hl">happy to help</span> you meet your objectives.</>,
    description = "Request free advice by filling out the form — we'll get back to you within 24 hours.",
    primaryText = "Contact us",
    primaryTo = "/contact",
    secondaryText = "Chat on WhatsApp",
    secondaryHref = null,
}) {
    const { contact } = useContact();
    const whatsappRaw = contact && contact.whatsapp_primary ? contact.whatsapp_primary : "+917597544999";
    const phoneDigits = whatsappRaw.toString().replace(/\D/g, "");
    const defaultMessage = "Hi, can you please help me?";
    const computedHref = `https://api.whatsapp.com/send?phone=${phoneDigits}&text=${encodeURIComponent(defaultMessage)}`;
    const finalSecondaryHref = secondaryHref || computedHref;
    return (
        <section className="global-cta">
            <div className="container global-cta-inner">
                <div className="global-cta-copy">
                    <h2>{heading}</h2>
                    <p>{description}</p>
                </div>
                <div className="global-cta-actions">
                    <Link className="btn btn-primary" to={primaryTo}>{primaryText}</Link>
                    <a className="btn btn-ghost-light" href={finalSecondaryHref} rel="noopener noreferrer" target="_blank">{secondaryText}</a>
                </div>
            </div>
        </section>
    );
}
